import { useEffect } from 'react';

import { ThemeProvider } from '@joinrepublic/dls-ui-kit';
import Head from 'next/head';

import { ErrorBoundary } from '@r-client/republic/feature/errors';
import {
  InvestmentOpportunities,
  useInvestmentOpportunitiesAnalytics,
} from '@r-client/republic/feature/investment-opportunities';
import { MainLayout } from '@r-client/republic/feature/main-layout';
import { theme } from '@r-client/republic/ui/theme';

const InvestmentOpportunitiesPage = () => {
  const { pageViewed } = useInvestmentOpportunitiesAnalytics();

  useEffect(() => {
    pageViewed();
  }, [pageViewed]);

  return (
    <ThemeProvider theme={theme}>
      <MainLayout>
        <Head>
          <title>Explore investment opportunities on Republic</title>
        </Head>
        <ErrorBoundary>
          <InvestmentOpportunities />
        </ErrorBoundary>
      </MainLayout>
    </ThemeProvider>
  );
};

export default InvestmentOpportunitiesPage;
